function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5 18h-4.535a3.5 3.5 0 00-6.93 0H5a3 3 0 01-3-2.999V15h2v-1H2v-1h2v-1H2V9.007A4.002 4.002 0 016.006 5h8.995A6.005 6.005 0 0121 11.005v3.996c0 .35-.06.687-.17.999H23v2h-5.5zM9 8H7.003A1 1 0 006 9.01v1.98A1 1 0 007.003 12H9V8zm1 0v4h1.997A1 1 0 0013 10.99V9.01A1 1 0 0011.997 8H10zm5 2.99V16h3v-5.01a1 1 0 00-.999-.99h-1.002a.992.992 0 00-.999.99zm-5.5 9.76a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationRvPark = function SvgLocationRvPark(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationRvPark;